module.exports = __webpack_public_path__ + "static/media/home-slide02.355331db.png";